import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Scrollbar from 'react-scrollbars-custom'
import cn from 'classnames'

import styles from './styles.module.scss'

const hoursArr = Array(24).fill(0).map((item, index) => {
  const name = index < 10 ? `0${index}` : `${index}`
  return {name, code: name}
})

const minutesArr = Array(4).fill(0).map((item, index) => {
  const minute = index * 15
  const name = minute < 10 ? `0${minute}` : `${minute}`
  return {name, code: name}
})

const TimePicker = forwardRef(({onChange}, ref) => {
  const { t } = useTranslation()

  const hoursScrollRef = useRef(null)
  const minutesScrollRef = useRef(null)

  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState({hour: '08', minute: '00'})

  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true)
    }
  }))

  const handleSelect = (type, value) => () => {
    setSelected({...selected, [type]: value})
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = (e) => {
    e.stopPropagation()
    onChange(`${selected.hour}:${selected.minute}`)
    setOpen(false)
  }

  if (!open) {
    return null
  }

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={cn(styles.container, {[styles.open]: open})}>
        <div className={styles.title}>
          { t('Set clock out time') }
        </div>
        <div className={styles.labels}>
          <div>{t('Hours')}</div>
          <div>{t('Minutes')}</div>
        </div>
        <div className={styles.timePicker}>
          <Scrollbar
            noScrollX
            trackYProps={{
              renderer: ({ elementRef, ...restProps }) => (
                <span
                  {...restProps}
                  ref={elementRef}
                  className={cn('trackY', styles.scrollbarTrackY)}
                />
              ),
            }}
            ref={hoursScrollRef}
          >
            {
              hoursArr.map((item) => {
                const isSelected = selected.hour === item.code
                return (
                  <div key={item.code} className={cn(styles.time, {[styles.selected]: isSelected})} onClick={handleSelect('hour', item.code)}>
                    {item.name}
                  </div>
                )
              })
            }
          </Scrollbar>
          <Scrollbar
            noScrollX
            trackYProps={{
              renderer: ({ elementRef, ...restProps }) => (
                <span
                  {...restProps}
                  ref={elementRef}
                  className={cn('trackY', styles.scrollbarTrackY)}
                />
              ),
            }}
            ref={minutesScrollRef}
          >
            {
              minutesArr.map((item) => {
                const isSelected = selected.minute === item.code
                return (
                  <div key={item.code} className={cn(styles.time, {[styles.selected]: isSelected})} onClick={handleSelect('minute', item.code)}>
                    {item.name}
                  </div>
                )
              })
            }
          </Scrollbar>
        </div>
        <div className={styles.button} onClick={handleSubmit}>
          { t('Set time') }
        </div>
      </div>
    </ClickAwayListener>
  )
})

export default TimePicker
